
import React, { useRef, Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { Button, ModalBody, ModalFooter, ModalHeader, Modal, FormGroup, ButtonGroup } from 'reactstrap';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import { toast } from 'components/Shared/Toast';

import { fetcher } from 'api/client';
import { getEthereumBalance } from 'api/actions/users';
import { contractAction } from 'api/actions/contracts';
import bootbox from '../Bootbox';

function DepositView({ contract, isOpen, toggle }) {

    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const ammountRef = useRef(null);
    const passwordRef = useRef(null);

    const { data: { balance } = {} } = useQuery(['contract-balance'], () => fetcher(contractAction(contract._id, 'getbalance', {})), { refetchOnWindowFocus: false, enabled: false });
    const { data: { walletBalance } = {} } = useQuery(['user-balance'], () => fetcher(getEthereumBalance()), { enabled: false })

    const { mutate: mutateDepositAmount, isLoading } = useMutation((payload) => fetcher(contractAction(contract._id, 'fundcontract', payload),), {
        onSuccess: () => {
            queryClient.invalidateQueries('contract-balance');
            toast.success(t('success'));
            toggle();
        },
        onError: (error) => {
            toast.error(t('errors.' + error.message), t('errors.GeneralError'))
        }
    })

    const fundContract = async () => {
        const confirm = await bootbox.confirm(t('blockchain.confirm_fund'));
        if (!confirm) return;
        const amount = ammountRef.current.value;
        // const password = passwordRef.current.value;
        mutateDepositAmount({ amount });
    }

    let amount = null;
    if (contract) amount = contract.elements?.find((element) => Object.keys(element.smartclause || {}).length)?.smartclause?.amount

    function copyToClipboard() {
        navigator.clipboard.writeText(contract._address);
        toast.success(t('common.copied_clipboard'));
    };

    return (
        <Modal isOpen={isOpen} centered size="lg">
            <ModalHeader toggle={toggle}>
                {t('blockchain.Deposit')}
            </ModalHeader>
            <ModalBody>

                <div>
                    <label>{t('blockchain.document_amount')}</label>
                </div>

                <div>
                    <span>{amount} ETH</span>
                </div>

                <div>
                    <label>{t('blockchain.current_balance')}</label>
                </div>

                <div>
                    <span>{balance} ETH</span>
                </div>
                <div>
                    <label>{t('blockchain.contract_address')}</label>
                </div>
                <div onClick={copyToClipboard}>
                    <div>
                        <span>{contract._address}</span>
                    </div>

                    <div>
                        <img src={contract.addressQR} alt={contract._address} />
                    </div>
                </div>

                {walletBalance ?
                    <Fragment>
                        <div>
                            <label>{t('blockchain.my_balance')}: {walletBalance} ETH</label>
                        </div>

                        <FormGroup>
                            <input type="number"
                                ref={ammountRef}
                                defaultValue={amount}
                                placeholder={t('blockchain.amount_to_transfer')}
                                className="form-control" />
                            {/* <input type="password"
                                    ref={passwordRef}
                                    placeholder={t('blockchain.password')}
                                    className="form-control" /> */}
                            <Button
                                className="form-button"
                                block={true}
                                size="md"
                                color="primary"
                                type="button"
                                disabled={isLoading}
                                onClick={fundContract} >
                                {t('blockchain.fund')}
                            </Button>
                        </FormGroup>
                    </Fragment> :
                    <div>
                        <label>{t('blockchain.fund_instructions')}</label>
                    </div>
                }

            </ModalBody>
            <ModalFooter>
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button type="button" size="md" onClick={toggle} block>
                        {t('blockchain.cancel')}
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    )
}

function Deposit(props) {
    return <DepositView {...props} />
}
export default Deposit;